import Header from './components/Header';
import FirstScreen from './components/FirstScreen';
import OrderSection from './components/OrderSection';
import RouteZones from './components/RouteZones';
import NewsFeed from './components/NewsFeed';
import ForumRank from './components/ForumRank';
import TopicFaq from './components/TopicFaq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#fbf8f3]">
      <Header />
      <main>
        <FirstScreen />
        <OrderSection />
        <RouteZones />
        <NewsFeed />
        <ForumRank />
        <TopicFaq />
      </main>
      <Footer />
    </div>
  );
}